import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import WebsiteBlogFormLayer from "../components/WebsiteBlogFormLayer";

const WebsiteBlogFormPage = () => {
    return (
        <MasterLayout>
            <WebsiteBlogFormLayer />
        </MasterLayout>
    );
};

export default WebsiteBlogFormPage;
